import { createSlice } from "@reduxjs/toolkit"
import { loginFormObject } from "@form/loginFormFields"

export const loginSlice = createSlice({
  name: 'login',
  initialState: {
    loginFormObject: { ...loginFormObject },
    errors: []
  },
  reducers: {
    updateLoginFormObject: (state, action) => {
      state.loginFormObject = action.payload
    },
    updateLoginErrors: (state, action) => {
      state.errors = action.payload
    },
    initLogin: (state) => {
      return { ...state, errors: [], loginFormObject: { ...loginFormObject } }
    }
  }
})

export const { updateLoginFormObject, updateLoginErrors, initLogin } = loginSlice.actions

export default loginSlice.reducer